
const TeacherDetails= ({user}) =>{
    return <div className="teacher-details">
        <h2>Teacher Details</h2>
        <div>Teacher Id: {user._id}</div>
        <div>Name: {user.name}</div>
        <div>Address: {user.address}</div>
    </div>
}

export default TeacherDetails